var _path, _path2, _rect, _line, _line2, _line3, _line4, _g, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenItemIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 40.5L36 44",
    stroke: "#1A1B1D",
    strokeWidth: 2.625,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43 24.75V24.75C43 20.884 39.866 17.75 36 17.75V17.75C32.134 17.75 29 20.884 29 24.75L29 31.75",
    stroke: "#1A1B1D",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.625,
    y: 33.5,
    width: 22.75,
    height: 19.25,
    rx: 0.35,
    stroke: "#1A1B1D",
    strokeWidth: 2.625,
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 14.5,
    y1: 23.2476,
    x2: 18.5001,
    y2: 23.2476,
    stroke: "#1A1B1D",
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 23.2476,
    x2: 12.0001,
    y2: 23.2476,
    stroke: "#1A1B1D",
    strokeWidth: 1.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 13.25,
    y1: 28.5,
    x2: 13.25,
    y2: 24.4999,
    stroke: "#1A1B1D",
    strokeWidth: 1.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 13.25,
    y1: 22,
    x2: 13.25,
    y2: 17.9999,
    stroke: "#1A1B1D",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter0_f_929_83229)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 58,
    width: 22,
    height: 7,
    rx: 0.35,
    fill: "#1A1B1D"
  }))), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 61.5,
    y1: 29.2476,
    x2: 65.5001,
    y2: 29.2476,
    stroke: "#1A1B1D",
    strokeWidth: 1.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 55,
    y1: 29.2476,
    x2: 59.0001,
    y2: 29.2476,
    stroke: "#1A1B1D",
    strokeWidth: 1.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 60.25,
    y1: 34.5,
    x2: 60.25,
    y2: 30.4999,
    stroke: "#1A1B1D",
    strokeWidth: 1.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 60.25,
    y1: 28,
    x2: 60.25,
    y2: 23.9999,
    stroke: "#1A1B1D",
    strokeWidth: 1.5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 54,
    y1: 11,
    x2: 57.0477,
    y2: 11,
    stroke: "#1A1B1D",
    strokeWidth: 1.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 49,
    y1: 11,
    x2: 52.0477,
    y2: 11,
    stroke: "#1A1B1D",
    strokeWidth: 1.5
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 53,
    y1: 15.0479,
    x2: 53,
    y2: 12.0002,
    stroke: "#1A1B1D",
    strokeWidth: 1.5
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 53,
    y1: 10.0479,
    x2: 53,
    y2: 7.00019,
    stroke: "#1A1B1D",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_929_83229",
    x: 17,
    y: 50,
    width: 38,
    height: 23,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_929_83229"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenItemIcon);
export default __webpack_public_path__ + "static/media/open-item-icon.54d2e2cfb3e7d0bd6f91341e15b4195d.svg";
export { ForwardRef as ReactComponent };